import Text from '@planday-corp/ui/text/Text';
import styled from 'styled-components';

export const StyledErrorContainer = styled.div`
  /* Respecting the logo margin */
  height: calc(100vh - 12.5rem);
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const StyledContent = styled.div`
  margin: 2rem;
  width: 30rem;
`;

export const StyledIllustration = styled.img`
  @media (max-height: 568px), (max-width: 320px) {
    display: none;
  }
  margin-bottom: 2rem;
`;

export const StyledTitleText = styled(Text)`
  margin-bottom: 0.25rem;
`;

export const StyledBodyText = styled(Text)`
  margin-bottom: 1rem;
`;

export const StyledButtonContainer = styled.div`
  margin-bottom: 1rem;
`;
